module.exports = __webpack_public_path__ + "static/img/avatar.80852360.png";